module.exports = __webpack_public_path__ + "img/18.69e3b667.jpg";